import React from 'react';
import { useSystemUsers } from '../hooks/use-system-users.js';
import SystemUsersPageView from './system-users-page-view.jsx';

function SystemUsersPageContainer() {
  const state = useSystemUsers();
  return <SystemUsersPageView {...state} />;
}

export default SystemUsersPageContainer;

